import type { Stage } from '../../types';

export const pregnancy1Zh: Stage = {
  id: 'pregnancy-1',
  key: '1',
  title: '孕早期',
  subtitle: '接纳小小的生命',
  weeks: '〜13周',
  description:
    '这是孕吐和身体变化较大的时期。不要勉强自己，从今天起一项一项整理好所需的手续和信息。',
  mindCards: [
    {
      id: 'm1',
      title: '让身体成为盟友',
      body: '困了睡，想吃就吃。不必每天都一样。',
      type: 'body',
    },
    {
      id: 'm2',
      title: '一小步一小步前进',
      body: '母子手册和产院手续，从今天起一项一项完成就好。',
      type: 'mind',
    },
    {
      id: 'm3',
      title: '与伴侣一起',
      body: '分享怀孕的喜讯，夫妻一起商量未来的分工。',
      type: 'mind',
    },
    {
      id: 'm4',
      title: '不要隐藏不安',
      body: '对身心变化感到困惑是自然的。先确定可以咨询的窗口。',
      type: 'mind',
    },
    {
      id: 'm5',
      title: '开始记录医疗费',
      body: '把收据和就诊记录集中整理，后续手续会更顺利。',
      type: 'life',
    },
    {
      id: 'm6',
      title: '持续补充叶酸',
      body: '通过饮食和补剂补充，并在医生或药师指导下持续服用。',
      type: 'body',
    },
    {
      id: 'm7',
      title: '用“母子Mo”接收信息',
      body: '注册新潟市育儿应援App“母子Mo”，确认通知和咨询窗口。（新潟市示例）',
      type: 'life',
    },
    {
      id: 'm8',
      title: '防范二手烟',
      body: '包括加热式香烟，不要让孕妇和婴幼儿身边有人吸烟。',
      type: 'partner',
    },
  ],
  checklist: [
    { id: 'c1', text: '领取母子手册并填写必要事项', category: 'admin', note: '可在居住地的市町村申请。新潟市还会指导注册“母子Mo”App。' },
    { id: 'c2', text: '确定妇产科并预约初诊产检', category: 'hospital', note: '确认交通便利性和夜间应对。' },
    { id: 'c3', text: '确认叶酸补剂与饮食平衡', category: 'body', note: '孕前〜孕早期以每日400微克为参考（因人而异）。' },
    { id: 'c4', text: '确认禁烟、禁酒及咖啡因摄入标准', category: 'body', note: '咖啡因每日控制在200毫克以内。' },
    { id: 'c5', text: '考虑向职场报告的时机', category: 'admin', note: '很多人选择在稳定期过后报告。' },
    { id: 'c6', text: '了解产假、育儿假手续', category: 'admin', note: '确认公司规定与雇佣保险条件。' },
    { id: 'c7', text: '了解分娩费用与生育一次性补贴概要', category: 'admin', note: '向健康保险组合或自治体咨询。' },
    { id: 'c8', text: '开始记录孕期情况', category: 'life', note: '体重、血压、孕吐状况等。' },
    { id: 'c9', text: '与伴侣商量家务分担', category: 'partner', note: '具体分配任务。' },
    { id: 'c10', text: '记录初次产检想问的问题', category: 'hospital', note: '准备问题清单。' },
    { id: 'c11', text: '把孕吐对策融入生活', category: 'body', note: '冷饮、少量多餐、休息等。' },
    { id: 'c12', text: '不对身心变化感到惊讶，原谅自己', category: 'mind', note: '这个时期情绪容易不稳定。' },
    { id: 'c13', text: '保管医疗费收据', category: 'admin', note: '高额疗养费或控除可能 later 需要。' },
    { id: 'c14', text: '准备孕妇标识', category: 'shopping', note: '在电车和职场使用会很方便。' },
    { id: 'c15', text: '查找附近的助产院、咨询窗口', category: 'hospital', note: '记住作为紧急联络方式。' },
    { id: 'c16', text: '与伴侣分享分娩设想', category: 'partner', note: '陪产、回娘家分娩等方针。' },
    { id: 'c17', text: '调整睡眠节律', category: 'life', note: '容易疲劳的时期不要勉强睡觉。' },
    { id: 'c18', text: '审视通勤路线的负担', category: 'life', note: '调整拥挤时段和能坐下的时段。' },
    { id: 'c19', text: '注意营养均衡的饮食', category: 'body', note: '以一汤三菜为基础，注意蔬菜、蛋白质和铁质。' },
    { id: 'c20', text: '确认产假所需文件', category: 'admin', note: '有时需要医生诊断书。' },
    { id: 'c21', text: '注册母子Mo（新潟育儿应援App）', category: 'admin', note: '新潟市示例。其他自治体可能有同名App或不同通知服务。' },
    { id: 'c22', text: '申请孕产妇医疗费补助', category: 'admin', note: '领取母子健康手册后尽早办理。补助期间从受给资格认定日开始。' },
    { id: 'c23', text: '确认孕妇支援给付金（第1次）申请', category: 'admin', note: '确认胎儿心跳之日起2年内。新潟市示例。' },
    { id: 'c24', text: '确认国民健康保险、国民年金产前产后免除', category: 'admin', note: '预产期前6个月起可申报。年金领取额不减少。' },
    { id: 'c25', text: '饮食以一汤三菜、盐分低于6.5克为参考', category: 'body', note: '孕中期起+250千卡、孕晚期・哺乳期+450千卡为参考（一般论）。' },
    { id: 'c26', text: '市售药和补剂不自行判断，咨询医生', category: 'body', note: '药物成分可能影响胎儿。' },
    { id: 'c27', text: '每天坚持口腔护理', category: 'body', note: '牙周病会增加早产风险，活用孕妇牙科健诊。' },
    { id: 'c28', text: '注意含汞量高的鱼类过量摄入', category: 'body', note: '金目鲷、剑鱼、南鲔金枪鱼、大眼金枪鱼等每周1〜2次并注意量。' },
  ],
  shopping: [
    {
      id: 's1',
      name: '孕妇标识',
      priority: 'must',
      timing: '随时',
      priceYenMin: 0,
      priceYenMax: 1000,
      note: '市町村或医院可能免费发放',
    },
    {
      id: 's2',
      name: '叶酸补剂',
      priority: 'must',
      timing: '孕早期起',
      priceYenMin: 1500,
      priceYenMax: 4500,
      note: '因人而异，请咨询医生',
    },
    {
      id: 's3',
      name: '妊娠纹护理油/乳霜',
      priority: 'nice',
      timing: '孕中期起',
      priceYenMin: 2000,
      priceYenMax: 6000,
      note: '注意保湿',
    },
    {
      id: 's4',
      name: '纯棉宽松内裤',
      priority: 'should',
      timing: '随时',
      priceYenMin: 1500,
      priceYenMax: 4000,
      note: '选择不紧绷的材质',
    },
    {
      id: 's5',
      name: '保暖家居服',
      priority: 'should',
      timing: '随时',
      priceYenMin: 3000,
      priceYenMax: 8000,
      note: '让孕吐期也能舒适度过',
    },
    {
      id: 's6',
      name: '体重/体脂秤',
      priority: 'nice',
      timing: '随时',
      priceYenMin: 2000,
      priceYenMax: 8000,
      note: '产检需要管理体重',
    },
    {
      id: 's7',
      name: '孕期日记本',
      priority: 'nice',
      timing: '随时',
      priceYenMin: 1000,
      priceYenMax: 3000,
      note: '也可用手机App代替',
    },
    {
      id: 's8',
      name: '低刺激护肤套装',
      priority: 'should',
      timing: '随时',
      priceYenMin: 2000,
      priceYenMax: 6000,
      note: '这个时期皮肤容易敏感',
    },
    {
      id: 's9',
      name: '孕妇枕',
      priority: 'nice',
      timing: '孕中期起',
      priceYenMin: 3000,
      priceYenMax: 10000,
      note: '肚子变大后会很实用',
    },
    {
      id: 's10',
      name: '无咖啡因饮料',
      priority: 'should',
      timing: '随时',
      priceYenMin: 1000,
      priceYenMax: 3000,
      note: '大麦茶、路易波士茶等',
    },
    {
      id: 's11',
      name: '保冷环保袋',
      priority: 'nice',
      timing: '随时',
      priceYenMin: 1000,
      priceYenMax: 3000,
      note: '产检时补水方便',
    },
    {
      id: 's12',
      name: '孕妇文胸/哺乳文胸',
      priority: 'should',
      timing: '孕中期〜晚期',
      priceYenMin: 2000,
      priceYenMax: 6000,
      note: '优先穿着舒适，产后也能用的款式',
    },
    {
      id: 's13',
      name: '口腔护理套装（小头牙刷、漱口水）',
      priority: 'should',
      timing: '随时',
      priceYenMin: 500,
      priceYenMax: 2000,
      note: '孕吐时难刷牙可用小头牙刷或漱口水',
    },
  ],
  warnings: [
    { id: 'w1', label: '剧烈腹痛或出血', level: 'urgent' },
    { id: 'w2', label: '意识模糊', level: 'urgent' },
    { id: 'w3', label: '单侧剧痛', level: 'urgent' },
    { id: 'w4', label: '孕吐严重到无法进食', level: 'watch' },
    { id: 'w5', label: '发热38°C以上', level: 'watch' },
    { id: 'w6', label: '排尿困难或疼痛', level: 'watch' },
    { id: 'w7', label: '剧烈头痛或恶心', level: 'watch' },
    { id: 'w8', label: '下腹部紧绷', level: 'watch' },
    { id: 'w9', label: '少量出血持续', level: 'watch' },
  ],
  partner: [
    { id: 'p1', text: '一起选产院并参观' },
    { id: 'p2', text: '表态承担家务' },
    { id: 'p3', text: '留出一起写孕期记录的时间' },
    { id: 'p4', text: '在孕吐期照顾饮食' },
    { id: 'p5', text: '承包晚上跑腿和购物' },
    { id: 'p6', text: '与公司确认产假计划' },
    { id: 'p7', text: '不催促妈妈，建议休息' },
    { id: 'p8', text: '在家庭中彻底防范二手烟' },
  ],
  tips: [
    {
      id: 't1',
      title: '孕吐与其说是“晕车”，不如说是“吃”的问题',
      body: '空腹往往会更难受。常备少量能吃的东西，心情会轻松很多。',
    },
    {
      id: 't2',
      title: '选产院，“方便去”很重要',
      body: '除了设备，还要确认紧急联络、夜间体制、工作人员氛围。',
    },
    {
      id: 't3',
      title: '养成“记录医疗费”的习惯',
      body: '把收据收在母子手册口袋里。有助于估算分娩费用和准备控除。',
    },
    {
      id: 't4',
      title: '报告职场要留有余裕',
      body: '即使还没进入稳定期，在身体状态稳定时告诉上司，后续调整更容易。',
    },
    {
      id: 't5',
      title: '孕吐对策：冷、小、勤补水',
      body: '用水、茶、无糖苏打水等勤补水。饭菜放凉有时更容易入口。',
    },
    {
      id: 't6',
      title: '饮食基础是一汤三菜',
      body: '搭配主食、主菜、副菜、汤，盐分每日控制在6.5克以下。注意叶酸、铁、钙。',
    },
    {
      id: 't7',
      title: '禁烟禁酒也包括二手烟',
      body: '也要避免加热式香烟，车内和家人面前绝对不要吸烟。',
    },
    {
      id: 't8',
      title: '市售药不要自行判断',
      body: '孕期、哺乳期用药请务必咨询妇产科医生、主治医生或药师。',
    },
  ],
  adminGuide: [
    {
      id: 'a1',
      title: '母子手册发放',
      body: '在居住地市町村窗口申请。确认怀孕后尽早领取，并同时确认产检就诊券等。',
      when: '确认怀孕后立即',
    },
    {
      id: 'a2',
      title: '生育一次性补贴概要',
      body: '加入健康保险者每次分娩可领取给付金。2023年10月起可抵扣分娩费用（产科医疗补偿制度）。',
      when: '分娩前后办理',
    },
    {
      id: 'a3',
      title: '孕妇产检补助券',
      body: '贴在母子手册上的就诊券，可让一定次数的产检更便宜。次数和金额因自治体而异。',
      when: '领取母子手册时',
    },
    {
      id: 'a4',
      title: '产假、育儿假取得手续',
      body: '产假可从预产期前6周开始（多胎为14周）。育儿假可在分娩后8周起取得。请确认雇佣保险给付条件。',
      when: '孕中期〜晚期向公司申请',
    },
    {
      id: 'a5',
      title: '医疗费控除、高额疗养费',
      body: '全年医疗费超过10万日元时，确定申报可能控除。请保管好收据。',
      when: '分娩翌年确定申报',
    },
    {
      id: 'a6',
      title: '孕产妇医疗费补助申请',
      body: '以居住在新潟市的孕产妇为对象，补助除部分负担金以外的医疗费。因补助期间从受给资格认定日开始，请尽早申请。',
      when: '领取母子健康手册后立即',
    },
    {
      id: 'a7',
      title: '孕妇支援给付金（第1次）',
      body: '以在新潟市提交妊娠申报的孕妇为对象。确认胎儿心跳之日起2年内通过电子申请办理。',
      when: '孕早期起',
    },
    {
      id: 'a8',
      title: '国民健康保险、国民年金产前产后免除',
      body: '产前产后期间保险费可免除或减轻。年金领取额不减少。预产期前6个月起可申报。',
      when: '孕中期〜产后',
    },
  ],
};

export const pregnancy2Zh: Stage = {
  id: 'pregnancy-2',
  key: '2',
  title: '孕中期',
  subtitle: '让稳定期成为盟友',
  weeks: '14–27周',
  description:
    '很多人孕吐会减轻，这是准备的黄金期。推进购物和手续，也要让身体动起来。',
  mindCards: [
    {
      id: 'm1',
      title: '让稳定期成为盟友',
      body: '在不过度的范围内活动身体，找回节奏。',
      type: 'body',
    },
    {
      id: 'm2',
      title: '统筹安排',
      body: '感受宝宝的成长，有计划地推进购物和手续。',
      type: 'mind',
    },
    {
      id: 'm3',
      title: '享受购物',
      body: '列出婴儿用品清单，从必需品开始准备。',
      type: 'life',
    },
    {
      id: 'm4',
      title: '商量产后分工',
      body: '与伴侣一起挑选用品，讨论产后分担。',
      type: 'mind',
    },
    {
      id: 'm5',
      title: '感受胎动',
      body: '察觉到小小的动作会更真实。突然减少请咨询医生。',
      type: 'body',
    },
    {
      id: 'm6',
      title: '与职场协调',
      body: '趁稳定期开始商量产假前的工作交接。',
      type: 'partner',
    },
    {
      id: 'm7',
      title: '注意铁质和钙质',
      body: '通过红肉、鱼、小松菜补铁；通过牛奶、酸奶、小松菜补钙。',
      type: 'body',
    },
    {
      id: 'm8',
      title: '提前安排产后支持',
      body: '考虑产后照护事业、娘家支持、家政服务等。',
      type: 'life',
    },
  ],
  checklist: [
    { id: 'c1', text: '确认产检日程', category: 'hospital', note: '孕中期通常每4周一次。' },
    { id: 'c2', text: '制定婴儿用品优先级清单', category: 'shopping', note: '按必需/推荐/有更好分类。' },
    { id: 'c3', text: '了解婴儿服装尺寸', category: 'shopping', note: '以新生儿〜50〜60厘米为主。' },
    { id: 'c4', text: '规划婴儿房或睡觉位置', category: 'life', note: '考虑放在卧室还是客厅。' },
    { id: 'c5', text: '确认预产期并向职场报告', category: 'admin', note: '按公司规定提交文件。' },
    { id: 'c6', text: '确认健康保险的高额疗养费制度', category: 'admin', note: '也可考虑取得限度额适用认定证。' },
    { id: 'c7', text: '决定回娘家分娩还是住院分娩', category: 'admin', note: '包括交通和家族支持。' },
    { id: 'c8', text: '确认宠物、探病等对策', category: 'life', note: '也想象出院后的环境。' },
    { id: 'c9', text: '开始拍孕妇照或写日记', category: 'life', note: '不必每天，留下记录即可。' },
    { id: 'c10', text: '确保运动时间（遵医嘱）', category: 'body', note: '不勉强的运动和拉伸。' },
    { id: 'c11', text: '关注饮食平衡与体重增加', category: 'body', note: '以BMI对应的推荐增重为参考（因人而异）。' },
    { id: 'c12', text: '与伴侣确认产后支持', category: 'partner', note: '夜间、家务、购物的分担。' },
    { id: 'c13', text: '寻找分娩相关书籍或讲座', category: 'mind', note: '夫妻一起参加的讲座也很推荐。' },
    { id: 'c14', text: '准备孕妇装', category: 'shopping', note: '选择对腹部友好的材质。' },
    { id: 'c15', text: '比较婴儿车和安全座椅', category: 'shopping', note: '去实体店看实物。' },
    { id: 'c16', text: '向产院确认分娩费用参考', category: 'admin', note: '也问单间和选项。' },
    { id: 'c17', text: '了解奶瓶和母乳相关用品', category: 'shopping', note: '了解哺乳和吸奶的选项。' },
    { id: 'c18', text: '佩戴孕妇标识', category: 'life', note: '在电车和设施使用。' },
    { id: 'c19', text: '留意胎动变化', category: 'body', note: '很多人从18〜22周左右开始感觉到。' },
    { id: 'c20', text: '与朋友、前辈妈妈交流信息', category: 'mind', note: '和同期的人聊天会安心。' },
    { id: 'c21', text: '留意工作交接', category: 'admin', note: '整理优先级和担当者。' },
    { id: 'c22', text: '与家人商量产后支持体制', category: 'partner', note: '也考虑娘家或帮手。' },
    { id: 'c23', text: '确定分娩设施并预约分娩', category: 'hospital', note: '包括回娘家分娩，早预约更安心。' },
    { id: 'c24', text: '接受孕妇牙科健诊', category: 'hospital', note: '孕16〜30周左右为参考。蛀牙和牙周病会增加早产风险。' },
    { id: 'c25', text: '开始正式准备婴儿用品', category: 'shopping', note: '以短内衣、长内衣各4〜5件、寝具、尿布、洗浴用品等为主。' },
    { id: 'c26', text: '考虑利用产后照护事业（住宿、日间、上门）', category: 'admin', note: '新潟市示例。原则上需从怀孕8个月起在使用日10天前申请。' },
    { id: 'c27', text: '申请国民健康保险、国民年金产前产后免除', category: 'admin', note: '预产期前6个月起可申报。年金领取额不减少。' },
    { id: 'c28', text: '开始适度运动（经医生许可）', category: 'body', note: '散步、孕妇瑜伽、游泳等。' },
    { id: 'c29', text: '注意含汞量高的鱼类摄入', category: 'body', note: '鲑鱼、竹荚鱼、青花鱼、金枪鱼罐头可放心。大眼金枪鱼、剑鱼、南鲔金枪鱼、金目鲷要控制量。' },
    { id: 'c30', text: '确认体重增加参考', category: 'body', note: '以自身BMI对应的推荐增重为参考（一般论）。' },
    { id: 'c31', text: '调查保育设施与育儿支援', category: 'admin', note: '为产后复职做准备，也确认家庭支援中心等（新潟市示例）。' },
    { id: 'c32', text: '与伴侣可视化家务分担', category: 'partner', note: '从孕期起共享倒垃圾、洗衣、家电使用等。' },
  ],
  shopping: [
    {
      id: 's1',
      name: '孕妇装',
      priority: 'should',
      timing: '孕中期起',
      priceYenMin: 3000,
      priceYenMax: 10000,
      note: '选择有弹性的材质',
    },
    {
      id: 's2',
      name: '婴儿内衣（短内衣、长内衣）',
      priority: 'must',
      timing: '孕中期起',
      priceYenMin: 2000,
      priceYenMax: 6000,
      note: '新生儿尺寸50〜60厘米各4〜5件',
    },
    {
      id: 's3',
      name: '少量尿布（新生儿尺寸）',
      priority: 'must',
      timing: '孕晚期起',
      priceYenMin: 1500,
      priceYenMax: 5000,
      note: '建议先少量试用再大量购买',
    },
    {
      id: 's4',
      name: '婴儿保湿剂、沐浴剂',
      priority: 'should',
      timing: '孕中期起',
      priceYenMin: 1500,
      priceYenMax: 4000,
      note: '选择低刺激、无添加',
    },
    {
      id: 's5',
      name: '哺乳文胸',
      priority: 'should',
      timing: '孕晚期起',
      priceYenMin: 2000,
      priceYenMax: 6000,
      note: '优先穿着舒适',
    },
    {
      id: 's6',
      name: '孕妇抱枕',
      priority: 'nice',
      timing: '孕中期起',
      priceYenMin: 3000,
      priceYenMax: 10000,
      note: '辅助侧睡',
    },
    {
      id: 's7',
      name: '婴儿车',
      priority: 'should',
      timing: '孕中期〜',
      priceYenMin: 20000,
      priceYenMax: 80000,
      note: '建议去实体店试推',
    },
    {
      id: 's8',
      name: '安全座椅（0岁适用）',
      priority: 'must',
      timing: '孕晚期',
      priceYenMin: 20000,
      priceYenMax: 50000,
      note: '选择新生儿可用型。出院时需要',
    },
    {
      id: 's9',
      name: '婴儿被褥、婴儿床',
      priority: 'must',
      timing: '孕晚期',
      priceYenMin: 15000,
      priceYenMax: 60000,
      note: '决定同睡还是睡床。使用期短可考虑租赁',
    },
    {
      id: 's10',
      name: '哺乳靠垫',
      priority: 'should',
      timing: '孕晚期〜产后',
      priceYenMin: 2000,
      priceYenMax: 6000,
      note: '减轻产后腰部负担',
    },
    {
      id: 's11',
      name: '婴儿背带',
      priority: 'should',
      timing: '孕晚期〜产后',
      priceYenMin: 3000,
      priceYenMax: 15000,
      note: '确认是否适合新生儿',
    },
    {
      id: 's12',
      name: '产后内裤',
      priority: 'must',
      timing: '孕晚期',
      priceYenMin: 2000,
      priceYenMax: 5000,
      note: '产后大码3〜5条',
    },
    {
      id: 's13',
      name: '婴儿浴盆、沐浴套装',
      priority: 'should',
      timing: '孕中期〜晚期',
      priceYenMin: 2000,
      priceYenMax: 8000,
      note: '套装包含水温计、毛巾、低刺激洗剂',
    },
    {
      id: 's14',
      name: '孕妇文胸、哺乳文胸',
      priority: 'should',
      timing: '孕中期起',
      priceYenMin: 2000,
      priceYenMax: 6000,
      note: '优先舒适，产后也能用的款式',
    },
  ],
  warnings: [
    { id: 'w1', label: '规律性腹痛或出血', level: 'urgent' },
    { id: 'w2', label: '疑似破水', level: 'urgent' },
    { id: 'w3', label: '头痛或视力异常', level: 'urgent' },
    { id: 'w4', label: '手部麻木', level: 'watch' },
    { id: 'w5', label: '腿部水肿', level: 'watch' },
    { id: 'w6', label: '体重急剧增加', level: 'watch' },
    { id: 'w7', label: '胎动减少', level: 'watch' },
    { id: 'w8', label: '心悸或气短严重', level: 'watch' },
    { id: 'w9', label: '尿漏或疼痛', level: 'watch' },
    { id: 'w10', label: '眼睛闪烁或剧烈头痛', level: 'watch' },
    { id: 'w11', label: '胎动急剧减少', level: 'watch' },
  ],
  partner: [
    { id: 'p1', text: '一起去买婴儿用品' },
    { id: 'p2', text: '把产后分工列表化' },
    { id: 'p3', text: '陪同产院参观' },
    { id: 'p4', text: '帮忙拍孕妇照' },
    { id: 'p5', text: '承担夜间家务' },
    { id: 'p6', text: '准备分娩费用' },
    { id: 'p7', text: '一起学习育儿书或讲座' },
    { id: 'p8', text: '每天确认妈妈状态' },
    { id: 'p9', text: '从孕期开始练习产后家务分担' },
  ],
  tips: [
    {
      id: 't1',
      title: '稳定期也不要勉强',
      body: '即使孕吐减轻，身体也在发生巨大变化。旅行、搬家要有计划，在不过度的范围内进行。',
    },
    {
      id: 't2',
      title: '婴儿用品从“必需”开始准备',
      body: '可爱的东西容易让人眼花缭乱。先准备内衣、尿布、被褥、安全座椅等必需品。',
    },
    {
      id: 't3',
      title: '胎动个体差异很大',
      body: '初产妇可能20周后才感觉到。如果突然减少或停止，请联系产院。',
    },
    {
      id: 't4',
      title: '报告职场也要准备书面材料',
      body: '产假、育儿假申请有时需要医生诊断书。提前向人事确认所需文件会更安心。',
    },
    {
      id: 't5',
      title: '体重增加按BMI来',
      body: '孕中期+250千卡、孕晚期和哺乳期+450千卡为参考。但遵守BMI别推荐增重更重要。',
    },
    {
      id: 't6',
      title: '注意铁质和钙质',
      body: '孕期容易贫血，胎儿骨骼和牙齿形成也需要钙。多吃红肉、鱼、小松菜、牛奶、酸奶。',
    },
    {
      id: 't7',
      title: '孕妇牙科健诊在稳定期',
      body: '孕16〜30周左右可免费接受1次。牙周病会增加早产和低出生体重风险，请尽早就诊。',
    },
    {
      id: 't8',
      title: '产后照护要尽早考虑',
      body: '新潟市的产后照护事业有住宿型、日间型、上门型。原则上从怀孕8个月起可申请。',
    },
  ],
  adminGuide: [
    {
      id: 'a1',
      title: '产假申请',
      body: '可从预产期前6周（多胎为14周）开始取得。按公司规定提交申请书和医生诊断书。',
      when: '孕中期〜晚期',
    },
    {
      id: 'a2',
      title: '高额疗养费制度',
      body: '1个月医疗费较高时，超过健康保险限额的部分可退还。事先取得限度额适用认定证可减轻窗口负担。',
      when: '产检增多的中期以后',
    },
    {
      id: 'a3',
      title: '婴儿用品领取服务',
      body: '自治体或保健中心可能免费或补助发放婴儿服、尿布、奶粉等。请在市町村网站确认产前产后支援制度。',
      when: '随时确认',
    },
    {
      id: 'a4',
      title: '回娘家分娩手续',
      body: '在父母居住的自治体接受产检或分娩时，可能需要转出申报、健康保险手续。产院也可能需要介绍信，请确认。',
      when: '决定回娘家分娩后',
    },
    {
      id: 'a5',
      title: '育儿休业给付金',
      body: '育儿假期间可从雇佣保险领取给付金。确认取得期间和工资条件，与公司协调。',
      when: '产假前计划',
    },
    {
      id: 'a6',
      title: '决定分娩设施并预约分娩',
      body: '包括回娘家分娩，尽早决定分娩医院并预约。受欢迎的设施容易约满。',
      when: '孕中期较早阶段',
    },
    {
      id: 'a7',
      title: '孕妇牙科健诊',
      body: '孕期蛀牙和牙周病容易恶化，会增加早产风险。领取母子健康手册的孕妇可免费接受1次。',
      when: '孕16〜30周左右',
    },
    {
      id: 'a8',
      title: '国民健康保险、国民年金产前产后免除',
      body: '产前产后期间保险费可免除或减轻。年金领取额不减少。预产期前6个月起可申报。',
      when: '孕中期〜产后',
    },
    {
      id: 'a9',
      title: '产后照护事业利用申请',
      body: '新潟市有住宿型、日间型、上门型产后照护。原则上从怀孕8个月起至使用日10天前需申请（因自治体而异）。',
      when: '孕中期〜晚期',
    },
    {
      id: 'a10',
      title: '孕产妇医疗费补助申请',
      body: '以居住在新潟市的孕产妇为对象，补助除部分负担金以外的医疗费。因补助期间从受给资格认定日开始，请尽早申请。',
      when: '领取母子健康手册后立即',
    },
  ],
};

export const pregnancy3Zh: Stage = {
  id: 'pregnancy-3',
  key: '3',
  title: '孕晚期',
  subtitle: '做好准备，善待身体',
  weeks: '28周〜',
  description: '肚子变大，分娩临近。准备好住院物品，巩固产后支持网络。',
  mindCards: [
    { id: 'm1', title: '用准备减少不安', body: '一项项完成清单，会增加内心的从容。', type: 'mind' },
    { id: 'm2', title: '善待身体', body: '避免久站和长时间移动，优先休息。', type: 'body' },
    { id: 'm3', title: '分辨阵痛和破水', body: '确认联络方式和时机，做到不慌不乱。', type: 'life' },
    { id: 'm4', title: '安排产后支持', body: '预约家务和育儿支持，建立保护妈妈的体制。', type: 'mind' },
    { id: 'm5', title: '选定儿科', body: '确认附近儿科和夜间诊疗体制，为突发发热做准备。', type: 'life' },
    { id: 'm6', title: '明确伴侣角色', body: '陪产、家务、联络人。确定具体角色。', type: 'partner' },
    { id: 'm7', title: '体重管理坚持到最后', body: '以BMI对应的推荐增重为参考，孕晚期注意+450千卡左右。', type: 'body' },
    { id: 'm8', title: '哺乳与吸奶的想象', body: '包括母乳和奶粉混合，不要慌张地准备。', type: 'mind' },
  ],
  checklist: [
    { id: 'c1', text: '准备住院包', category: 'shopping', note: '母子手册、保险证、换洗衣物、卫生用品。' },
    { id: 'c2', text: '确认产院住院日程', category: 'hospital', note: '入院方式、携带物品、探视时间等。' },
    { id: 'c3', text: '登记阵痛出租车和联系方式', category: 'life', note: '确认有夜间应对的公司。' },
    { id: 'c4', text: '与家人共享紧急联络方式', category: 'admin', note: '产院、出租车、娘家等。' },
    { id: 'c5', text: '确认新生儿家访健诊预约', category: 'hospital', note: '自治体家访和1个月健诊。' },
    { id: 'c6', text: '安排产后帮手', category: 'life', note: '娘家、帮手、产后照护事业。' },
    { id: 'c7', text: '补齐婴儿用品最后一批', category: 'shopping', note: '确认必需品是否齐全。' },
    { id: 'c8', text: '准备分娩费用', category: 'admin', note: '确认现金、刷卡、转账对应方式。' },
    { id: 'c9', text: '确认生育一次性补贴申请手续', category: 'admin', note: '产院直接抵扣或自行申请。' },
    { id: 'c10', text: '制定回娘家或移动计划', category: 'admin', note: '交通方式和紧急应对。' },
    { id: 'c11', text: '确认分辨阵痛和破水', category: 'body', note: '决定何时联系产院。' },
    { id: 'c12', text: '确认父亲产假和陪产', category: 'partner', note: '产院规则和公司手续。' },
    { id: 'c13', text: '商量夜间应对和联络人', category: 'partner', note: '阵痛开始时要联系谁。' },
    { id: 'c14', text: '观察胎动，不放过异常', category: 'body', note: '活用胎动记录卡。' },
    { id: 'c15', text: '选定儿科并确认诊疗时间', category: 'hospital', note: '也确认夜间和假日。' },
    { id: 'c16', text: '确认出生申报写法', category: 'admin', note: '分娩后14天内提交。' },
    { id: 'c17', text: '洗完婴儿服', category: 'life', note: '新生儿内衣用中性洗涤剂。' },
    { id: 'c18', text: '确认安全座椅安装', category: 'shopping', note: '为出院时做好准备。' },
    { id: 'c19', text: '考虑产后餐单', category: 'life', note: '列出预制菜和熟食清单。' },
    { id: 'c20', text: '确保放松时间', category: 'mind', note: '用按摩或音乐放松。' },
    { id: 'c21', text: '与伴侣确认分娩计划书', category: 'partner', note: '阵痛中的应对、是否陪产。' },
    { id: 'c22', text: '确认无痛分娩等分娩方式希望', category: 'hospital', note: '确认产院是否对应。' },
    { id: 'c23', text: '确认阵痛出租车登记和夜间应对', category: 'life', note: '确认早晚深夜应对和费用体系。' },
    { id: 'c24', text: '确认儿科假日、夜间体制', category: 'hospital', note: '尽早决定常去的儿科。' },
    { id: 'c25', text: '申请父亲产假（出生育儿假）', category: 'partner', note: '分娩后8周内最多可取得4周。需在休业开始预定日2周前向公司提出。' },
    { id: 'c26', text: '确认孕妇支援给付金（第2次）申请', category: 'admin', note: '预产期8周前等起2年内。新潟市示例。' },
    { id: 'c27', text: '申请产后照护事业利用', category: 'admin', note: '新潟市示例。原则上怀孕8个月起至使用日10天前。有住宿、日间、上门。' },
    { id: 'c28', text: '确认回娘家分娩的转出手续', category: 'admin', note: '健康保险、住民票可能需要移动。' },
    { id: 'c29', text: '向产院确认分娩费用支付方式', category: 'admin', note: '现金、刷卡、转账、直接抵扣（生育一次性补贴）等。' },
    { id: 'c30', text: '最终确认住院清单', category: 'shopping', note: '各产院有免带物品，需提前确认。' },
    { id: 'c31', text: '在家中制定禁烟规则', category: 'life', note: '孕妇、婴幼儿身边绝对禁烟。' },
  ],
  shopping: [
    { id: 's1', name: '住院包一套', priority: 'must', timing: '孕晚期', priceYenMin: 5000, priceYenMax: 15000, note: '母子手册、保险证、产后护垫、前开睡衣、洗漱用品等' },
    { id: 's2', name: '产后内裤', priority: 'must', timing: '孕晚期', priceYenMin: 2000, priceYenMax: 5000, note: '产后大码3〜5条' },
    { id: 's3', name: '防溢乳垫', priority: 'must', timing: '孕晚期', priceYenMin: 1000, priceYenMax: 3000, note: '一次性或布制' },
    { id: 's4', name: '婴儿服（含出院服）', priority: 'must', timing: '孕晚期', priceYenMin: 3000, priceYenMax: 10000, note: '新生儿尺寸和50〜60厘米各准备4〜5件左右' },
    { id: 's5', name: '婴儿被褥、婴儿床', priority: 'must', timing: '孕晚期', priceYenMin: 15000, priceYenMax: 60000, note: '选择同睡用品或婴儿床。也可考虑租赁' },
    { id: 's6', name: '婴儿背带', priority: 'should', timing: '孕晚期〜产后', priceYenMin: 3000, priceYenMax: 15000, note: '确认是否适合新生儿' },
    { id: 's7', name: '哺乳靠垫', priority: 'should', timing: '孕晚期〜产后', priceYenMin: 2000, priceYenMax: 6000, note: '减轻哺乳时腰部负担' },
    { id: 's8', name: '安全座椅（0岁适用）', priority: 'must', timing: '孕晚期', priceYenMin: 20000, priceYenMax: 50000, note: '出院时需要。也要确认安装' },
    { id: 's9', name: '新生儿尿布（大量）', priority: 'must', timing: '孕晚期', priceYenMin: 4000, priceYenMax: 12000, note: '按每天10片以上准备' },
    { id: 's10', name: '婴儿湿巾', priority: 'must', timing: '孕晚期', priceYenMin: 1000, priceYenMax: 3000, note: '新生儿低刺激型' },
    { id: 's11', name: '奶瓶、奶嘴套装', priority: 'should', timing: '孕晚期〜产后', priceYenMin: 2000, priceYenMax: 6000, note: '为母乳和奶粉两方面做准备' },
    { id: 's12', name: '婴儿体温计', priority: 'should', timing: '孕晚期', priceYenMin: 2000, priceYenMax: 5000, note: '选择耳式、非接触式或腋式' },
    { id: 's13', name: '哺乳文胸（含住院用）', priority: 'must', timing: '孕晚期', priceYenMin: 2000, priceYenMax: 6000, note: '优先前开、舒适' },
    { id: 's14', name: '产后护垫、产褥垫', priority: 'must', timing: '孕晚期', priceYenMin: 1500, priceYenMax: 5000, note: '住院中到产后2〜3周份' },
    { id: 's15', name: '阵痛出租车登记（费用参考）', priority: 'should', timing: '孕晚期', priceYenMin: 0, priceYenMax: 5000, note: '因自治体和出租车公司而异。有的需提前登记' },
  ],
  warnings: [
    { id: 'w1', label: '破水', level: 'urgent' },
    { id: 'w2', label: '出血', level: 'urgent' },
    { id: 'w3', label: '阵痛', level: 'urgent' },
    { id: 'w4', label: '剧烈头痛或视线模糊', level: 'urgent' },
    { id: 'w5', label: '意识模糊', level: 'urgent' },
    { id: 'w6', label: '胎动减少', level: 'watch' },
    { id: 'w7', label: '腿部水肿', level: 'watch' },
    { id: 'w8', label: '手部麻木', level: 'watch' },
    { id: 'w9', label: '无法入睡', level: 'watch' },
    { id: 'w10', label: '持续呕吐或腹泻', level: 'watch' },
    { id: 'w11', label: '胎动极度减少', level: 'watch' },
    { id: 'w12', label: '手脚或脸部水肿急剧增加', level: 'watch' },
  ],
  partner: [
    { id: 'p1', text: '确认住院包内容' },
    { id: 'p2', text: '决定阵痛时联络人' },
    { id: 'p3', text: '最终确认产后家务和育儿分担' },
    { id: 'p4', text: '确认安全座椅安装' },
    { id: 'p5', text: '一起调查儿科候选' },
    { id: 'p6', text: '确认分娩计划书希望' },
    { id: 'p7', text: '确认回娘家时的交通' },
    { id: 'p8', text: '提醒妈妈优先休息' },
    { id: 'p9', text: '向公司申请产后爸爸育儿假' },
  ],
  tips: [
    { id: 't1', title: '住院包在34〜36周前完成', body: '为突发入院做好准备，母子手册、保险证、产后护垫、换洗衣物收在一起。把内容给伴侣看会更好。' },
    { id: 't2', title: '登记阵痛出租车就安心', body: '确认夜间和清晨应对，把联系方式存进手机。即使不用，知道存在也会安心。' },
    { id: 't3', title: '胎动“减少”马上联系', body: '胎动比平时明显减少时，请联系产院。不要不好意思，尽快咨询很重要。' },
    { id: 't4', title: '产后家务不必“完美”', body: '打扫和洗衣尽量最低限度。利用熟食和预制菜。产后妈妈的恢复最优先。' },
    { id: 't5', title: '儿科也要确认夜间和假日', body: '为突发发热做准备，决定常去儿科和夜间/假日可就诊的医院清单。' },
    { id: 't6', title: '回娘家分娩不要忘记手续', body: '在父母居住的自治体接受产检或分娩时，可能需要办理健康保险和住民票手续。' },
    { id: 't7', title: '产后照护从怀孕8个月起申请', body: '新潟市有住宿型、日间型、上门型产后照护。需在使用日10天前申请，所以要尽早。' },
    { id: 't8', title: '彻底防范二手烟', body: '制定孕妇、婴幼儿身边不吸烟的规则。换气扇下也防不了侧流烟。' },
  ],
  adminGuide: [
    { id: 'a1', title: '提交出生申报', body: '在宝宝出生后14天内，向父母本籍或居住地的市区町村提交。所需文件由产院交付。', when: '出生后14天内' },
    { id: 'a2', title: '申请生育一次性补贴', body: '加入健康保险者每次分娩可领取。可选择产院直接抵扣或自行申请。', when: '分娩时或分娩后' },
    { id: 'a3', title: '婴幼儿医疗证发放', body: '提交出生申报后，会收到婴幼儿医疗费补助手续指南。儿科就诊时出示即可。', when: '提交出生申报后' },
    { id: 'a4', title: '预约产后照护事业', body: '自治体和产院提供住宿或上门产后照护。可获得休息和育儿支持。新潟市示例。', when: '孕晚期〜产后不久' },
    { id: 'a5', title: '父亲产假', body: '产后8周内可取得“出生育儿假”。从雇佣保险领取给付金。请提前向公司申请。', when: '孕晚期向公司申请' },
    { id: 'a6', title: '回娘家分娩的转出手续', body: '在父母居住的自治体分娩或产检时，可能需要办理健康保险和住民票移动。请提前确认。', when: '分娩前调整' },
    { id: 'a7', title: '孕妇支援给付金（第2次）', body: '以在新潟市分娩的产妇为对象。预产期8周前等起2年内通过电子申请办理。', when: '分娩前后' },
    { id: 'a8', title: '产后照护事业利用申请', body: '新潟市有住宿型、日间型、上门型。原则上从怀孕8个月起至使用日10天前需申请。', when: '孕晚期' },
    { id: 'a9', title: '国民健康保险、国民年金产前产后免除', body: '产前产后期间保险费可免除或减轻。年金领取额不减少。预产期前6个月起可申报。', when: '孕晚期〜产后' },
    { id: 'a10', title: '儿童医疗电话咨询（#8000）', body: '新潟市等地在夜间/假日对孩子疾病或受伤是否就诊感到迷茫时，可咨询护士等。因自治体而异。', when: '随时记住' },
  ],
};

export const birthZh: Stage = {
  id: 'birth',
  key: '4',
  title: '分娩前后',
  subtitle: '用自己的方式面对未知旅程',
  weeks: '分娩前后',
  description: '分娩不可预测。不要忘记重要手续，与伴侣一起调整呼吸。',
  mindCards: [
    { id: 'm1', title: '相信自己', body: '分娩是未知旅程。相信自己的身体和医护人员，托付给他们。', type: 'mind' },
    { id: 'm2', title: '产后不着急', body: '恢复不要急躁，累积小小的休息。', type: 'body' },
    { id: 'm3', title: '与伴侣调整呼吸', body: '一起迎接新家庭。即使只是搭话也是很大的支持。', type: 'mind' },
    { id: 'm4', title: '想象出院后的生活', body: '整理好家庭环境和可以求助的体制。', type: 'life' },
    { id: 'm5', title: '与宝宝的肌肤接触', body: '通过沐浴和换尿布，一点点培养亲子信赖。', type: 'partner' },
    { id: 'm6', title: '手续按计划推进', body: '按照产院和自治体的指引，推进出生申报和各种申请。', type: 'life' },
    { id: 'm7', title: '母乳和奶粉都不着急', body: '母乳不是马上就有，用奶粉补充也没关系。不要责怪自己。', type: 'mind' },
  ],
  checklist: [
    { id: 'c1', text: '完成住院手续', category: 'hospital', note: '保险证、母子手册、同意书等。' },
    { id: 'c2', text: '携带分娩计划书', category: 'hospital', note: '阵痛中的应对和缓痛希望。' },
    { id: 'c3', text: '确认伴侣陪产同意书', category: 'hospital', note: '遵守产院规则。' },
    { id: 'c4', text: '整理出院手续和所需文件', category: 'admin', note: '出生申报、诊断书、就诊券等。' },
    { id: 'c5', text: '确认出生申报准备和提交期限', category: 'admin', note: '出生后14天内。' },
    { id: 'c6', text: '确认母子手册发放', category: 'admin', note: '在产院或自治体。' },
    { id: 'c7', text: '办理生育一次性补贴申请手续', category: 'admin', note: '通过产院或健康保险组合。' },
    { id: 'c8', text: '确认婴幼儿医疗证手续', category: 'admin', note: '自治体儿童课等。' },
    { id: 'c9', text: '确认家庭环境（婴儿用品、温度）', category: 'life', note: '室温22〜26度、湿度50〜60%为参考。' },
    { id: 'c10', text: '确认哺乳准备和方法', category: 'body', note: '母乳或奶粉都可以。' },
    { id: 'c11', text: '确认新生儿沐浴方法', category: 'life', note: '在产院指导下进行。' },
    { id: 'c12', text: '确认夜间支持体制', category: 'partner', note: '哺乳和换尿布的分担。' },
    { id: 'c13', text: '列出出院后购物清单', category: 'shopping', note: '产后护垫、尿布、奶粉等。' },
    { id: 'c14', text: '确保观察妈妈恢复的时间', category: 'mind', note: '注意疼痛和出血的变化。' },
    { id: 'c15', text: '观察新生儿排泄和睡眠节律', category: 'life', note: '也记录母乳/奶粉次数。' },
    { id: 'c16', text: '准备产后餐食', category: 'body', note: '营养均衡和补水。' },
    { id: 'c17', text: '确认宝宝健诊预约', category: 'hospital', note: '1个月健诊和预防接种。' },
    { id: 'c18', text: '向伴侣表达感谢', category: 'mind', note: '小小的支持说出口才能持续。' },
    { id: 'c19', text: '出生后14天内提交出生申报', category: 'admin', note: '向父母本籍或居住地的市区町村。' },
    { id: 'c20', text: '申请儿童津贴', category: 'admin', note: '0岁儿至3岁每月15,000日元（有限制）。在出生当月月末前申请。' },
    { id: 'c21', text: '申请儿童医疗费补助', category: 'admin', note: '对象年龄和内容因自治体而异。加入健康保险后办理。' },
    { id: 'c22', text: '接受新生儿听力筛查和先天性代谢异常筛查', category: 'hospital', note: '听力筛查出生后立即，代谢异常筛查出生后4〜6天左右采血。' },
    { id: 'c23', text: '利用产后照护事业（如已申请）', category: 'admin', note: '住宿型、日间型、上门型。新潟市示例。' },
    { id: 'c24', text: '母乳和奶粉混合不着急', category: 'body', note: '母乳不足时用奶粉补充，在不过度的范围内。' },
    { id: 'c25', text: '伴侣取得产后爸爸育儿假', category: 'partner', note: '产后8周内最多4周。需在休业开始预定日2周前向公司提出。' },
    { id: 'c26', text: '确认家中二手烟防范', category: 'life', note: '孕妇、婴幼儿身边绝对禁烟。' },
  ],
  shopping: [
    { id: 's1', name: '产后夜用文胸', priority: 'must', timing: '分娩前后', priceYenMin: 2000, priceYenMax: 6000, note: '方便哺乳的设计' },
    { id: 's2', name: '产后护垫', priority: 'must', timing: '分娩前后', priceYenMin: 1500, priceYenMax: 5000, note: '住院中到产后2〜3周' },
    { id: 's3', name: '新生儿尿布', priority: 'must', timing: '分娩前后', priceYenMin: 2000, priceYenMax: 6000, note: '按每天10片以上准备' },
    { id: 's4', name: '奶粉套装（奶粉+奶瓶）', priority: 'should', timing: '分娩前后', priceYenMin: 3000, priceYenMax: 10000, note: '即使母乳混合也要准备' },
    { id: 's5', name: '哺乳巾', priority: 'should', timing: '分娩前后', priceYenMin: 2000, priceYenMax: 5000, note: '外出或来客时方便' },
    { id: 's6', name: '婴儿体温计', priority: 'should', timing: '分娩前后', priceYenMin: 2000, priceYenMax: 5000, note: '非接触式或耳式' },
    { id: 's7', name: '婴儿湿巾（大量）', priority: 'must', timing: '分娩前后', priceYenMin: 1000, priceYenMax: 3000, note: '新生儿低刺激型' },
    { id: 's8', name: '婴儿沐浴套装', priority: 'should', timing: '分娩前后', priceYenMin: 2000, priceYenMax: 6000, note: '水温计、毛巾、洗剂等' },
    { id: 's9', name: '哺乳枕', priority: 'nice', timing: '分娩前后', priceYenMin: 2000, priceYenMax: 6000, note: '减轻腰部负担' },
    { id: 's10', name: '妈妈用发带、拖鞋', priority: 'nice', timing: '分娩前后', priceYenMin: 1000, priceYenMax: 3000, note: '提升住院舒适度' },
    { id: 's11', name: '吸奶器（电动或手动）', priority: 'nice', timing: '分娩前后', priceYenMin: 3000, priceYenMax: 20000, note: '根据奶量和生活选择' },
    { id: 's12', name: '婴儿指甲剪', priority: 'should', timing: '分娩前后', priceYenMin: 500, priceYenMax: 2000, note: '新生儿安全设计' },
    { id: 's13', name: '尿布专用垃圾桶', priority: 'nice', timing: '分娩前后', priceYenMin: 2000, priceYenMax: 6000, note: '防异味' },
    { id: 's14', name: '奶瓶消毒器', priority: 'nice', timing: '分娩前后', priceYenMin: 2000, priceYenMax: 8000, note: '选择微波炉、药液、煮沸等类型' },
  ],
  warnings: [
    { id: 'w1', label: '大量出血', level: 'urgent' },
    { id: 'w2', label: '剧烈疼痛', level: 'urgent' },
    { id: 'w3', label: '意识丧失', level: 'urgent' },
    { id: 'w4', label: '呼吸困难', level: 'urgent' },
    { id: 'w5', label: '发热', level: 'watch' },
    { id: 'w6', label: '伤口疼痛', level: 'watch' },
    { id: 'w7', label: '乳房胀痛', level: 'watch' },
    { id: 'w8', label: '宝宝反应弱', level: 'watch' },
    { id: 'w9', label: '无法哺乳', level: 'watch' },
    { id: 'w10', label: '情绪低落严重', level: 'watch' },
    { id: 'w11', label: '新生儿黄疸严重或持续', level: 'watch' },
    { id: 'w12', label: '肚脐出血或化脓', level: 'watch' },
    { id: 'w13', label: '宝宝呼吸急促或痛苦', level: 'urgent' },
  ],
  partner: [
    { id: 'p1', text: '确认陪产或待机时能做些什么' },
    { id: 'p2', text: '准备接手出院后家务' },
    { id: 'p3', text: '提醒妈妈优先休息' },
    { id: 'p4', text: '一起推进出生申报和手续' },
    { id: 'p5', text: '支持夜间换尿布和哺乳' },
    { id: 'p6', text: '观察宝宝情况并报告妈妈' },
    { id: 'p7', text: '确认出院时交通' },
    { id: 'p8', text: '向公司申请产后爸爸育儿假' },
  ],
  tips: [
    { id: 't1', title: '把分娩计划当作“希望”', body: '阵痛和分娩无法预测。即使和计划不同，妈妈和宝宝的安全最优先。保持灵活。' },
    { id: 't2', title: '产后首先是水分和休息', body: '哺乳和恢复都需要水分。宝宝睡了一起睡。家务可以放一放。' },
    { id: 't3', title: '哺乳不用着急', body: '母乳不是马上就有，用奶粉补充也没关系。一边咨询助产师和母乳门诊，一边继续。' },
    { id: 't4', title: '换尿布要“安全、沉着”', body: '一开始会笨拙，一边和宝宝说话一边做会熟练。一定要洗手，不要移开视线。' },
    { id: 't5', title: '母乳和奶粉混合也可以', body: '不必过于执着于纯母乳。把妈妈的压力和宝宝的营养放在第一位。用奶粉也可以。' },
    { id: 't6', title: '新生儿急病请拨打#8000', body: '新潟市等地夜间/假日不确定是否就诊时，可通过儿童医疗电话咨询#8000咨询护士等。' },
    { id: 't7', title: '防范二手烟', body: '包括加热式香烟，制定孕妇、婴幼儿身边不吸烟的规则。换气扇下也防不了侧流烟。' },
    { id: 't8', title: '市售药咨询医生', body: '不要自行停用慢性病药或服用市售药。请务必咨询妇产科医生、主治医生或药师。' },
  ],
  adminGuide: [
    { id: 'a1', title: '提交出生申报', body: '出生后14天内，向父母本籍或居住地的市区町村提交。所需文件由产院交付。', when: '出生后14天内' },
    { id: 'a2', title: '申请生育一次性补贴', body: '加入健康保险者可通过产院直接抵扣分娩费用，或事后申请。手续由产院指导。', when: '分娩时或分娩后不久' },
    { id: 'a3', title: '婴幼儿医疗证发放', body: '提交出生申报后，自治体会送来婴幼儿医疗费补助手续指南。儿科就诊时出示即可。', when: '提交出生申报后' },
    { id: 'a4', title: '申请儿童津贴', body: '对象至初中3年级。0岁儿至3岁每月15,000日元（有限制）。在出生当月月末前申请。', when: '出生后立即' },
    { id: 'a5', title: '父亲出生育儿假', body: '产后8周内可取得。从雇佣保险领取给付金。请提前向公司申请。', when: '产后8周内' },
    { id: 'a6', title: '确认母子手册发放', body: '在产院或自治体领取母子健康手册，确认新生儿健诊日程。', when: '产后立即' },
    { id: 'a7', title: '新生儿听力筛查和先天性代谢异常筛查', body: '听力筛查出生后立即，代谢异常筛查出生后4〜6天左右采血。为了早发现，请接受。', when: '出生后立即〜1周左右' },
    { id: 'a8', title: '利用产后照护事业', body: '新潟市有住宿型、日间型、上门型产后照护。有时需提前申请。', when: '产后立即〜产后6个月' },
    { id: 'a9', title: '申请儿童医疗费补助', body: '补助儿童医疗费（保险诊疗部分）的自付额。因自治体而异。加入健康保险后办理。', when: '出生后尽快' },
    { id: 'a10', title: '新潟县“Komusubi”定期存款', body: '以新潟县内出生的1岁以下儿童为对象。在1岁生日前一天前通过县电子申请系统申请。', when: '1岁生日前一天前' },
    { id: 'a11', title: '儿童医疗电话咨询（#8000）', body: '新潟市等地夜间/假日对孩子疾病或受伤是否就诊感到迷茫时，可咨询护士等。', when: '紧急时' },
  ],
  careScenes: [
    {
      id: 'cs1',
      title: '换尿布',
      items: [
        '准备尿布、湿巾、防水垫',
        '一定要洗手，不要移开视线',
        '女孩从前向后擦',
        '尿布疹担心时薄涂保湿剂',
        '用过的尿布卫生处理',
      ],
    },
    {
      id: 'cs2',
      title: '哺乳・奶粉',
      items: [
        '母乳约3小时一次，按需即可',
        '奶粉按正确浓度和温度冲调',
        '奶瓶使用前后消毒',
        '不要忘记拍嗝',
        '哺乳后让宝宝侧卧约30分钟',
      ],
    },
    {
      id: 'cs3',
      title: '沐浴',
      items: [
        '温暖房间，备齐用品',
        '水温以38〜40度为参考',
        '轻柔清洗脖子、腋下、尿布区',
        '脸部用另备的清水轻擦',
        '洗完立即擦干并保湿',
      ],
    },
    {
      id: 'cs4',
      title: '外出',
      items: [
        '再次确认安全座椅安装',
        '多带尿布、湿巾、换洗衣物',
        '从短时间外出开始',
        '选择有哺乳设施的设施',
        '避开人群，不要勉强',
      ],
    },
  ],
};

export const postpartumEarlyZh: Stage = {
  id: 'postpartum-early',
  key: '5',
  title: '产后0–3个月',
  subtitle: '迎接新生命的每一天',
  weeks: '产后0–3个月',
  description: '哺乳和睡眠节律尚未稳定的时期。不要勉强，也要重视妈妈自身的恢复。',
  mindCards: [
    { id: 'm1', title: '不求完美', body: '迎接小小的生命，正确答案不止一个。', type: 'mind' },
    { id: 'm2', title: '一项项习惯', body: '在产院指导下，开始做盆底肌和不勉强的运动。', type: 'body' },
    { id: 'm3', title: '外出从短时间开始', body: '重视自己的节奏，在不过度范围内外出。', type: 'life' },
    { id: 'm4', title: '夜间互相支持', body: '支持夜间哺乳，想办法让妈妈休息。', type: 'mind' },
    { id: 'm5', title: '咨询是优势', body: '育儿烦恼不要一个人扛，可以向专家或自治体咨询。', type: 'mind' },
    { id: 'm6', title: '珍惜夫妻时间', body: '哪怕很短也要说话，继续两人的调整。', type: 'partner' },
    { id: 'm7', title: '哺乳按妈妈的节奏', body: '感觉母乳不足就混合奶粉。保护妈妈的身心最优先。', type: 'body' },
  ],
  checklist: [
    { id: 'c1', text: '在家提交出生申报', category: 'admin', note: '出生后14天内。' },
    { id: 'c2', text: '确认儿童津贴和特例给付申请', category: 'admin', note: '确认自治体送来的指南。' },
    { id: 'c3', text: '确认1个月健诊和预防接种日程', category: 'hospital', note: '记录在母子手册上。' },
    { id: 'c4', text: '开始记录哺乳和睡眠', category: 'life', note: 'App或笔记本都可以。' },
    { id: 'c5', text: '开始做盆底肌运动（遵医嘱）', category: 'body', note: '在不过度范围内。' },
    { id: 'c6', text: '预约产后6周健康检查', category: 'hospital', note: '在产院或自治体。' },
    { id: 'c7', text: '确认产后咨询窗口（自治体、保健所）', category: 'mind', note: '可能有夜间电话咨询。' },
    { id: 'c8', text: '降低家务节奏', category: 'life', note: '打扫降到最低限度。' },
    { id: 'c9', text: '与伴侣决定夜间和周末轮班', category: 'partner', note: '平均分配休息。' },
    { id: 'c10', text: '计划短时间外出', category: 'life', note: '从1〜2小时左右开始。' },
    { id: 'c11', text: '决定可以咨询育儿不安的人', category: 'mind', note: '助产师、保健师、前辈妈妈。' },
    { id: 'c12', text: '整理婴儿随身用品', category: 'life', note: '尿布、换衣的动线。' },
    { id: 'c13', text: '确认哺乳姿势和乳头护理', category: 'body', note: '疼痛持续时咨询。' },
    { id: 'c14', text: '准备参拜神社', category: 'life', note: '服装、日程、护身符等。' },
    { id: 'c15', text: '预约预防接种', category: 'hospital', note: 'BCG、轮状、Hib等。' },
    { id: 'c16', text: '优先妈妈的饮食和睡眠', category: 'mind', note: '按宝宝的节奏一起休息。' },
    { id: 'c17', text: '把对伴侣的感谢说出口', category: 'partner', note: '小事也要传达。' },
    { id: 'c18', text: '计划补充育儿用品', category: 'shopping', note: '尿布、湿巾等。' },
    { id: 'c19', text: '申请儿童医疗费补助', category: 'admin', note: '对象年龄和内容因自治体而异。加入健康保险后办理。' },
    { id: 'c20', text: '申请儿童津贴', category: 'admin', note: '0岁儿至3岁每月15,000日元（有限制）。在出生当月月末前。' },
    { id: 'c21', text: '确认新潟县“Komusubi”定期存款申请', category: 'admin', note: '以新潟县内出生的1岁以下儿童为对象。在1岁生日前一天前申请。' },
    { id: 'c22', text: '接受新生儿家访（“你好宝宝”）', category: 'hospital', note: '自治体通知。用于育儿和健康咨询。' },
    { id: 'c23', text: '预约产后6〜8周健康检查', category: 'hospital', note: '确认子宫恢复、贫血、血压、乳房、盆底肌等。' },
    { id: 'c24', text: '维护妈妈口腔护理和产后营养', category: 'body', note: '哺乳期也要注意铁和钙。哺乳期+450千卡为参考（一般论）。' },
    { id: 'c25', text: '确认育儿不安咨询窗口', category: 'mind', note: '新潟市助产师会“Hello Midwife”、各区儿童家庭中心等。' },
    { id: 'c26', text: '母乳和奶粉混合不着急', category: 'body', note: '母乳不足时混合奶粉。咨询妇产科或助产师。' },
    { id: 'c27', text: '在家中彻底防范二手烟', category: 'life', note: '孕妇、婴幼儿身边绝对禁烟。' },
    { id: 'c28', text: '妈妈饮食以+450千卡为参考保持均衡', category: 'body', note: '以一汤三菜为基础，注意铁和钙。' },
  ],
  shopping: [
    { id: 's1', name: '婴儿背带（新生儿可用）', priority: 'should', timing: '产后0〜3个月', priceYenMin: 3000, priceYenMax: 15000, note: '确认是否适合脖子未挺前' },
    { id: 's2', name: '哺乳文胸（产后尺寸）', priority: 'must', timing: '产后0〜3个月', priceYenMin: 2000, priceYenMax: 6000, note: '优先穿着舒适' },
    { id: 's3', name: '婴儿湿巾（大量）', priority: 'must', timing: '产后0〜3个月', priceYenMin: 2000, priceYenMax: 6000, note: '新生儿低刺激型' },
    { id: 's4', name: '婴儿浴巾', priority: 'should', timing: '产后0〜3个月', priceYenMin: 1000, priceYenMax: 3000, note: '纱布材质受欢迎' },
    { id: 's5', name: '婴儿监视器', priority: 'nice', timing: '产后0〜3个月', priceYenMin: 5000, priceYenMax: 20000, note: '很多类型带摄像头' },
    { id: 's6', name: '哺乳巾', priority: 'should', timing: '产后0〜3个月', priceYenMin: 2000, priceYenMax: 5000, note: '外出时方便' },
    { id: 's7', name: '产后内裤、骨盆带', priority: 'should', timing: '产后0〜3个月', priceYenMin: 2000, priceYenMax: 6000, note: '遵医嘱或助产师指导' },
    { id: 's8', name: '吸奶器（电动或手动）', priority: 'nice', timing: '产后0〜3个月', priceYenMin: 3000, priceYenMax: 20000, note: '根据奶量和生活选择' },
    { id: 's9', name: '婴儿指甲剪', priority: 'should', timing: '产后0〜3个月', priceYenMin: 500, priceYenMax: 2000, note: '新生儿安全设计' },
    { id: 's10', name: '妈妈放松用品', priority: 'nice', timing: '产后0〜3个月', priceYenMin: 1000, priceYenMax: 5000, note: '入浴剂、眼罩等' },
    { id: 's11', name: '尿布专用垃圾桶', priority: 'nice', timing: '产后0〜3个月', priceYenMin: 2000, priceYenMax: 6000, note: '防异味' },
    { id: 's12', name: '奶瓶消毒器', priority: 'nice', timing: '产后0〜3个月', priceYenMin: 2000, priceYenMax: 8000, note: '选择微波炉、药液、煮沸等类型' },
  ],
  warnings: [
    { id: 'w1', label: '大量恶露', level: 'urgent' },
    { id: 'w2', label: '发热39°C以上', level: 'urgent' },
    { id: 'w3', label: '胸痛', level: 'urgent' },
    { id: 'w4', label: '意识模糊', level: 'urgent' },
    { id: 'w5', label: '宝宝呼吸困难', level: 'urgent' },
    { id: 'w6', label: '恶露气味或量增加', level: 'watch' },
    { id: 'w7', label: '伤口疼痛', level: 'watch' },
    { id: 'w8', label: '哺乳疼痛', level: 'watch' },
    { id: 'w9', label: '情绪低落', level: 'watch' },
    { id: 'w10', label: '宝宝食欲下降', level: 'watch' },
    { id: 'w11', label: '肚脐出血或化脓', level: 'watch' },
    { id: 'w12', label: '黄疸严重或持续', level: 'watch' },
  ],
  partner: [
    { id: 'p1', text: '支持夜间哺乳' },
    { id: 'p2', text: '主导家务，让妈妈休息' },
    { id: 'p3', text: '观察妈妈状态并鼓励咨询' },
    { id: 'p4', text: '一起学换尿布和沐浴' },
    { id: 'p5', text: '周末给妈妈创造睡眠时间' },
    { id: 'p6', text: '一起咨询育儿烦恼' },
    { id: 'p7', text: '陪同预防接种和健诊' },
    { id: 'p8', text: '创造两人时间' },
    { id: 'p9', text: '取得产后爸爸育儿假' },
  ],
  tips: [
    { id: 't1', title: '睡眠要“和宝宝一起睡”', body: '夜间哺乳容易削减睡眠。白天宝宝睡了也一起躺下，恢复会不同。' },
    { id: 't2', title: '哺乳烦恼尽早咨询', body: '乳头疼痛或乳腺炎征兆可向母乳门诊或助产师咨询。不必一个人忍耐。' },
    { id: 't3', title: '家务保持“最低限度”', body: '打扫和洗衣降到最低。利用熟食和配送。产后妈妈还在恢复中。' },
    { id: 't4', title: '外出重视节奏', body: '第一次外出从1〜2小时开始。选择有哺乳设施的设施，不勉强地适应。' },
    { id: 't5', title: '产后抑郁请早期咨询', body: '这个时期容易情绪低落。不要责怪自己，活用妇产科、精神科或自治体咨询窗口。' },
    { id: 't6', title: '育儿不安咨询是优势', body: '可利用新潟市助产师会“Hello Midwife”、各区儿童家庭中心（Hot Station）、LINE咨询等。' },
    { id: 't7', title: '母乳和奶粉混合也可以', body: '不必过于执着纯母乳。选择妈妈压力小的方式，咨询助产师或妇产科。' },
    { id: 't8', title: '饮食哺乳期也按+450千卡参考', body: '以一汤三菜为基础，注意铁和钙。哺乳期也要充分补水。' },
    { id: 't9', title: '防范二手烟', body: '婴幼儿身边不吸烟。包括加热式香烟，换气扇也防不了侧流烟。' },
    { id: 't10', title: '急病请拨打#8000', body: '新潟市等地通过儿童医疗电话咨询#8000，可在夜间/假日咨询护士等。' },
  ],
  adminGuide: [
    { id: 'a1', title: '出生申报提交期限', body: '出生后14天内向市区町村提交。夫妻任何一方都可以。同时领取母子手册和健诊券。', when: '出生后14天内' },
    { id: 'a2', title: '申请儿童津贴', body: '0岁儿至3岁每月15,000日元（有限制）。向自治体儿童课申请。因收入可能减少或不支付。', when: '出生后立即' },
    { id: 'a3', title: '婴幼儿医疗证发放', body: '儿科就诊时出示可获得医疗费补助。对象年龄和内容因自治体而异。', when: '提交出生申报后' },
    { id: 'a4', title: '预防接种预诊票', body: '按母子手册上的日程接种。也可考虑轮状、Hib、肺炎球菌等自费疫苗。', when: '1〜2个月左右起' },
    { id: 'a5', title: '产后健康检查', body: '产后6〜8周接受。确认子宫恢复、贫血、血压、乳房、盆底肌等。也有自治体免费健诊。', when: '产后6〜8周' },
    { id: 'a6', title: '育儿假复职准备', body: '复职前3〜4个月开始与公司协调。也讨论保育园申请和工作方式。', when: '产后2〜3个月左右' },
    { id: 'a7', title: '申请儿童医疗费补助', body: '补助儿童医疗费（保险诊疗部分）的自付额。因自治体而异。加入健康保险后办理。', when: '出生后尽快' },
    { id: 'a8', title: '新潟县“Komusubi”定期存款', body: '以新潟县内出生的1岁以下儿童为对象。给付10万日元定期存款。在1岁生日前一天前通过县电子申请系统申请。', when: '1岁生日前一天前' },
    { id: 'a9', title: '利用产后照护事业', body: '新潟市有住宿型、日间型、上门型产后照护。如已申请则利用，未申请则咨询。', when: '产后〜生后6个月' },
    { id: 'a10', title: '父亲出生育儿假', body: '产后8周内最多可取得4周。从雇佣保险领取给付金。需在休业开始2周前向公司提出。', when: '产后8周内' },
  ],
  careScenes: [
    {
      id: 'cs1',
      title: '夜间哄睡',
      items: [
        '调暗房间，保持安静',
        '形成换尿布、哺乳、拍嗝的流程',
        '用白噪音或温柔声音安抚',
        '昼夜节律尚未形成，请接受',
        '也创造妈妈休息的时间',
      ],
    },
    {
      id: 'cs2',
      title: '哺乳・奶粉',
      items: [
        '母乳按需，妈妈身体也很重要',
        '奶粉按规定量、温度、浓度冲调',
        '哺乳后拍嗝',
        '乳头疼痛持续时咨询',
        '不要忘记补水',
      ],
    },
    {
      id: 'cs3',
      title: '换尿布',
      items: [
        '每次温柔擦拭臀部',
        '薄涂保湿剂预防尿布疹',
        '男孩女孩都从前向后擦',
        '换尿布台不要移开视线',
        '立即洗手',
      ],
    },
    {
      id: 'cs4',
      title: '外出',
      items: [
        '确认安全座椅安装',
        '多带尿布、湿巾、换洗衣物',
        '选择有哺乳设施的设施',
        '外出时间要短',
        '妈妈也注意补水和休息',
      ],
    },
  ],
};

export const postpartumLateZh: Stage = {
  id: 'postpartum-late',
  key: '6',
  title: '产后3–12个月',
  subtitle: '享受新的日常',
  weeks: '产后3–12个月',
  description:
    '宝宝成长显著。在自身恢复和找回夫妻时间的同时，迈向下一步。',
  mindCards: [
    {
      id: 'm1',
      title: '今天做到了的事',
      body: '不是完美，而是认可今天做到的小事。',
      type: 'mind',
    },
    {
      id: 'm2',
      title: '关注自身恢复',
      body: '不勉强地重新开始运动，持续骨盆和躯干护理。',
      type: 'body',
    },
    {
      id: 'm3',
      title: '计划辅食和预防接种',
      body: '有计划地推进6个月、9个月、1岁健诊和预防接种。',
      type: 'life',
    },
    {
      id: 'm4',
      title: '找回夫妻时间',
      body: '重视与伴侣的连接，哪怕很短也要说话。',
      type: 'mind',
    },
    {
      id: 'm5',
      title: '协调育儿与工作',
      body: '推进复职和保育园准备，找到适合自己的工作方式。',
      type: 'life',
    },
    {
      id: 'm6',
      title: '再调整伴侣角色',
      body: '根据成长重新调整家务和育儿分工，互相支持。',
      type: 'partner',
    },
    {
      id: 'm7',
      title: '去附近的游乐场',
      body: '利用育儿支援中心或公园获取外部刺激和妈妈朋友。新潟市的SKIP游乐场地图也很方便。',
      type: 'life',
    },
    {
      id: 'm8',
      title: '不要一个人扛',
      body: '知道可以使用家庭支援或临时托管，心会轻松。',
      type: 'mind',
    },
  ],
  checklist: [
    { id: 'c1', text: '预约乳儿一般健诊（3〜4个月、10个月）和1岁6个月健诊', category: 'hospital', note: '身体测量、发育确认、辅食咨询。新潟市示例。日程因自治体而异。' },
    { id: 'c2', text: '准备开始辅食', category: 'life', note: '5〜6个月左右。从软烂的10倍粥开始。' },
    { id: 'c3', text: '确认预防接种进度', category: 'hospital', note: 'BCG、轮状、Hib、肺炎球菌等。确认母子手册日程。' },
    { id: 'c4', text: '确认抚养控除和税务手续', category: 'admin', note: '年末调整或确定申报所需文件。' },
    { id: 'c5', text: '推进育儿假复职准备', category: 'admin', note: '调整工作时间、保育园接送。确认爸爸妈妈育儿假Plus。' },
    { id: 'c6', text: '计划保育园申请和参观', category: 'admin', note: '在自治体网站确认申请时期和入园标准。新潟市SKIP手册也可参考。' },
    { id: 'c7', text: '预约妈妈和宝宝牙科健诊', category: 'hospital', note: '乳牙萌出后就诊。' },
    { id: 'c8', text: '不勉强地重新开始运动', category: 'body', note: '从盆底肌和轻拉伸开始。' },
    { id: 'c9', text: '一点点恢复自己的爱好和时间', category: 'mind', note: '哪怕很短也要有自己的时间。' },
    { id: 'c10', text: '创造夫妻对话时间', category: 'partner', note: '也聊育儿以外的话题。' },
    { id: 'c11', text: '持续骨盆和躯干护理', category: 'body', note: '产后体型不急躁，持续进行。' },
    { id: 'c12', text: '记住产后抑郁咨询对象（一般名称）', category: 'mind', note: '精神科、心疗内科、各区儿童家庭中心等。' },
    { id: 'c13', text: '利用地域育儿支援中心', category: 'mind', note: '新潟市示例：Chulip、Aiai等。游戏、父母交流、咨询。' },
    { id: 'c14', text: '与伴侣重新确认分工', category: 'partner', note: '辅食、沐浴、夜间应对等。' },
    { id: 'c15', text: '准备参拜神社和行事', category: 'life', note: '服装、日程、护身符等。' },
    { id: 'c16', text: '享受宝宝手势和语言发展', category: 'life', note: '通过聊天和绘本。' },
    { id: 'c17', text: '审视防灾准备', category: 'life', note: '应急奶粉、尿布、联络方式。' },
    { id: 'c18', text: '重视妈妈自身的人际关系', category: 'mind', note: '与朋友、同世代妈妈交流。' },
    { id: 'c19', text: '准备符合成长的玩具和环境', category: 'shopping', note: '确认安全标准。也防范误吞、跌落、SIDS。' },
    { id: 'c20', text: '商量是否计划二胎（如需要）', category: 'partner', note: '共享时机、身体、生活规划。' },
    { id: 'c21', text: '持续确认儿童医疗费补助领取', category: 'admin', note: '新潟市示例。搬家或保险变更时申报。' },
    { id: 'c22', text: '调查家庭支援中心', category: 'admin', note: '新潟市示例。有偿志愿者接送、临时托管。' },
    { id: 'c23', text: '确认临时托管、短期托住服务', category: 'admin', note: '用于放松或急事。有的设施从生后数月起可用。' },
    { id: 'c24', text: '确认新潟县“Komusubi”定期存款申请期限', category: 'admin', note: '以新潟县内出生的1岁以下儿童为对象。在1岁生日前一天前。' },
    { id: 'c25', text: '确认常去儿科和#8000', category: 'hospital', note: '夜间/假日使用儿童医疗电话咨询#8000（新潟市等示例）。' },
    { id: 'c26', text: '1岁以下不喂蜂蜜', category: 'body', note: '预防婴儿肉毒杆菌症。也确认加工食品原料表。' },
  ],
  shopping: [
    {
      id: 's1',
      name: '辅食套装（餐具、勺子、围兜）',
      priority: 'should',
      timing: '5〜6个月左右',
      priceYenMin: 2000,
      priceYenMax: 8000,
      note: '吸盘碗和硅胶勺子方便',
    },
    {
      id: 's2',
      name: '宝宝餐椅',
      priority: 'should',
      timing: '5〜6个月左右',
      priceYenMin: 5000,
      priceYenMax: 25000,
      note: '用于辅食和家庭餐桌',
    },
    {
      id: 's3',
      name: '宝宝玩具',
      priority: 'nice',
      timing: '3〜12个月',
      priceYenMin: 1000,
      priceYenMax: 5000,
      note: '发声玩具、布绘本等',
    },
    {
      id: 's4',
      name: '婴儿车替换候选',
      priority: 'nice',
      timing: '3〜12个月',
      priceYenMin: 20000,
      priceYenMax: 60000,
      note: '能坐后考虑切换',
    },
    {
      id: 's5',
      name: '妈妈运动服',
      priority: 'nice',
      timing: '3〜12个月',
      priceYenMin: 3000,
      priceYenMax: 10000,
      note: '开始不勉强运动时',
    },
    {
      id: 's6',
      name: '育儿用品收纳',
      priority: 'nice',
      timing: '3〜12个月',
      priceYenMin: 2000,
      priceYenMax: 8000,
      note: '整理玩具和辅食用品',
    },
    {
      id: 's7',
      name: '牙刷、口腔护理用品',
      priority: 'should',
      timing: '6个月左右〜',
      priceYenMin: 1000,
      priceYenMax: 3000,
      note: '乳牙萌出后开始',
    },
    {
      id: 's8',
      name: '婴儿食品、辅食食材',
      priority: 'should',
      timing: '5〜6个月左右',
      priceYenMin: 2000,
      priceYenMax: 6000,
      note: '初期少量。确认过敏',
    },
    {
      id: 's9',
      name: '安全门、安全用品',
      priority: 'should',
      timing: '8〜12个月左右',
      priceYenMin: 3000,
      priceYenMax: 15000,
      note: '配合爬行和扶站',
    },
    {
      id: 's10',
      name: '绘本',
      priority: 'nice',
      timing: '3〜12个月',
      priceYenMin: 1000,
      priceYenMax: 5000,
      note: '从布绘本、纸板书开始',
    },
    {
      id: 's11',
      name: '妈妈背包',
      priority: 'nice',
      timing: '3〜12个月',
      priceYenMin: 3000,
      priceYenMax: 12000,
      note: '外出时解放双手的背包也方便',
    },
    {
      id: 's12',
      name: '尿布（M、L尺寸）',
      priority: 'must',
      timing: '3〜12个月',
      priceYenMin: 4000,
      priceYenMax: 12000,
      note: '随成长换尺寸',
    },
  ],
  warnings: [
    { id: 'w1', label: '高热惊厥', level: 'urgent' },
    { id: 'w2', label: '意识异常', level: 'urgent' },
    { id: 'w3', label: '呼吸异常', level: 'urgent' },
    { id: 'w4', label: '发育检查和成长曲线', level: 'watch' },
    { id: 'w5', label: '食欲下降', level: 'watch' },
    { id: 'w6', label: '妈妈情绪低落或疲惫', level: 'watch' },
    { id: 'w7', label: '辅食过敏反应', level: 'watch' },
    { id: 'w8', label: '发热38度以上', level: 'watch' },
  ],
  partner: [
    { id: 'p1', text: '重新确认育儿角色' },
    { id: 'p2', text: '创造夫妻共处时间' },
    { id: 'p3', text: '持续支持妈妈休息' },
    { id: 'p4', text: '一起做辅食和沐浴' },
    { id: 'p5', text: '一起推进保育园和复职计划' },
    { id: 'p6', text: '陪同预防接种和健诊' },
    { id: 'p7', text: '观察妈妈并鼓励咨询' },
    { id: 'p8', text: '哪怕很短也要创造两人时间' },
  ],
  tips: [
    { id: 't1', title: '辅食从“少量、单一”开始', body: '5〜6个月左右，从软烂的10倍粥开始。按月龄从舌压碎→牙龈压碎的硬度推进。最初1勺，观察3〜5天。' },
    { id: 't2', title: '预防接种预约可能难抢', body: 'BCG、轮状等接种时间有限，尽早预约。确认母子手册日程，不要忘记。' },
    { id: 't3', title: '复职和保育园要尽早收集信息', body: '在自治体网站确认保育园申请时期和认可/认可外区别。新潟市育儿应援手册“SKIP”有园一览和游乐场地图（因自治体而异）。' },
    { id: 't4', title: '夫妻时间重在“质”而非“长”', body: '哪怕15分钟一起吃饭、洗完澡聊聊天也好。定期重新审视育儿分担。' },
    { id: 't5', title: '事故预防按月龄重新审视', body: '定期检查误吞、跌落、浴槽、安全座椅（6岁以下有义务使用）。俯卧睡和二手烟会增加SIDS风险，请避免。' },
    { id: 't6', title: '不确定时拨打#8000', body: '新潟市等地夜间/假日不确定是否就诊时，可通过儿童医疗电话咨询#8000咨询护士等。' },
    { id: 't7', title: '1岁以下不喂蜂蜜', body: '为预防婴儿肉毒杆菌症，1岁前不要喂蜂蜜或含蜂蜜食品。' },
  ],
  adminGuide: [
    {
      id: 'a1',
      title: '保育园申请',
      body: '认可保育园需向自治体申请。确认申请时期、入园标准、所需文件，并计划参观。新潟市SKIP指南也可参考（因自治体而异）。',
      when: '产后3〜6个月左右起',
    },
    {
      id: 'a2',
      title: '育儿假复职手续',
      body: '复职日3〜4周前联系公司。调整工作时间、休息、短时工作。如果父母双方都取得，可确认爸爸妈妈育儿假Plus（可延长至1岁2个月）。',
      when: '复职前1〜2个月',
    },
    {
      id: 'a3',
      title: '抚养控除和税务手续',
      body: '年末调整或确定申报可能可以使用抚养控除和医疗费控除。整理收据和母子手册复印件。',
      when: '年末调整・确定申报期',
    },
    {
      id: 'a4',
      title: '预防接种预诊票',
      body: '按母子手册上的日程接种。自费疫苗的费用和时期也确认，并咨询儿科。',
      when: '1〜12个月左右',
    },
    {
      id: 'a5',
      title: '儿童津贴持续手续',
      body: '持续至初中3年级。收入、搬家等变动时需向自治体申报。',
      when: '有变动时随时',
    },
    {
      id: 'a6',
      title: '乳儿一般健康诊察',
      body: '在3〜4个月、10个月（乳儿一般健诊I・II）、1岁6个月、3岁等确认发育。可咨询辅食和育儿（新潟市示例/因自治体而异）。',
      when: '对应月龄',
    },
    {
      id: 'a7',
      title: '儿童医疗费补助',
      body: '补助儿童医疗费（保险诊疗部分）的自付额。搬家、保险变更时申报（新潟市示例）。',
      when: '随时或变更时',
    },
    {
      id: 'a8',
      title: '家庭支援中心',
      body: '连接需要育儿帮助的人和愿意帮忙的人的有偿志愿者。可用于接送、临时托管（新潟市示例）。',
      when: '需要保育时',
    },
    {
      id: 'a9',
      title: '临时托管、短期托住',
      body: '用于放松、生病、红白事等暂时托管。也有住宿型短期托住（育儿短期支援）（因自治体而异）。',
      when: '需要时',
    },
    {
      id: 'a10',
      title: '新潟县“Komusubi”定期存款',
      body: '以新潟县内出生的1岁以下儿童为对象。给付10万日元定期存款。在1岁生日前一天前通过县电子申请系统申请。',
      when: '1岁生日前一天前',
    },
    {
      id: 'a11',
      title: '儿童医疗电话咨询（#8000）',
      body: '新潟市等地夜间/假日对孩子疾病或受伤是否就诊感到迷茫时，可咨询护士等。',
      when: '紧急时或夜间/假日',
    },
  ],
  careScenes: [
    {
      id: 'cs1',
      title: '辅食',
      items: [
        '准备餐具、围兜、勺子',
        '最初1勺、单一食材，观察3〜5天',
        '过敏食材少量导入',
        '不吃完不要勉强',
        '餐后不要忘记补水',
      ],
    },
    {
      id: 'cs2',
      title: '外出',
      items: [
        '多带尿布、湿巾、换洗衣物',
        '选择有哺乳室或婴儿室的设施',
        '外出时间按妈妈和宝宝状态调整',
        '妈妈也注意补水和休息',
        '避开人群和长时间移动',
      ],
    },
    {
      id: 'cs3',
      title: '夜间哄睡',
      items: [
        '睡前创造平静时间',
        '固定洗澡、哺乳、刷牙流程',
        '夜哭有时不必立刻回应，先观察一下',
        '卧室调暗，保持适宜温度',
        '妈妈也不勉强，一起休息',
      ],
    },
    {
      id: 'cs4',
      title: '玩耍与刺激',
      items: [
        '把聊天和唱歌融入日常',
        '用布绘本、发声玩具培养五感',
        '趴卧游戏（tummy time）在看护下短时间进行',
        '创造感受户外空气和绿植的时间',
        '随成长准备安全环境',
      ],
    },
  ],
};

export const zhStages: Stage[] = [
  pregnancy1Zh,
  pregnancy2Zh,
  pregnancy3Zh,
  birthZh,
  postpartumEarlyZh,
  postpartumLateZh,
];
